import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNE = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M2.48 14.131A24.9 24.9 0 0 0 0 25.001a24.9 24.9 0 0 0 2.48 10.87L25 38.043l22.519-2.174A24.901 24.901 0 0 0 49.999 25a24.9 24.9 0 0 0-2.48-10.869l-22.52-2.174-22.518 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M2.481 35.87C6.525 44.232 15.088 50 25 50c9.912 0 18.475-5.768 22.518-14.13H2.481Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M2.481 14.13h45.036C43.474 5.768 34.911 0 25 0 15.088 0 6.525 5.768 2.481 14.13ZM25 33.695a8.695 8.695 0 1 0 0-17.39 8.695 8.695 0 0 0 0 17.39Z"
}));
FlagNE.displayName = 'FlagNE';
export default withFlagWrapper(FlagNE);
//# sourceMappingURL=index.js.map